var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "81px",
    viewBox: "0 0 80 81",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 26") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.000180451128 0.383759398 79.6156391 0.383759398 79.6156391 79.9999398 0.000180451128 79.9999398"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 80.2177444 79.6156391 80.2177444 79.6156391 0.601503759 0 0.601503759"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobil-\\u2013-Desktop",
    transform: "translate(-223.000000, -790.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(223.000000, 790.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.217744)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6158195,40.1918195 C79.6158195,62.1773835 61.7932632,79.9999398 39.8076992,79.9999398 C17.8227368,79.9999398 0.000180451128,62.1773835 0.000180451128,40.1918195 C0.000180451128,18.2062556 17.8227368,0.383699248 39.8076992,0.383699248 C61.7932632,0.383699248 79.6158195,18.2062556 79.6158195,40.1918195",
    id: "Fill-1",
    fill: "#3A913F",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.9999398,55.6633383 L39.9999398,55.6633383 C34.4817444,55.6633383 30.0083609,51.1899549 30.0083609,45.6717594 L30.0083609,30.1295038 C30.0083609,24.6113083 34.4817444,20.1379248 39.9999398,20.1379248 C45.5181353,20.1379248 49.9903158,24.6113083 49.9903158,30.1295038 L49.9903158,45.6717594 C49.9903158,51.1899549 45.5181353,55.6633383 39.9999398,55.6633383",
    id: "Fill-4",
    fill: "#3A913F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9046617,20.4254436 C31.4658647,20.4254436 30.2959398,21.5959699 30.2959398,23.0341654 L30.2959398,52.7676992 C30.2959398,54.2052932 31.4658647,55.375218 32.9046617,55.375218 L47.0953383,55.375218 C48.5323308,55.375218 49.7040602,54.2052932 49.7040602,52.7676992 L49.7040602,23.0341654 C49.7040602,21.5959699 48.5323308,20.4254436 47.0953383,20.4254436 L32.9046617,20.4254436 Z M47.0953383,55.9514586 L32.9046617,55.9514586 C31.1488722,55.9514586 29.7209023,54.5234887 29.7209023,52.7676992 L29.7209023,23.0341654 C29.7209023,21.2789774 31.1488722,19.850406 32.9046617,19.850406 L47.0953383,19.850406 C48.8505263,19.850406 50.2790977,21.2789774 50.2790977,23.0341654 L50.2790977,52.7676992 C50.2790977,54.5234887 48.8505263,55.9514586 47.0953383,55.9514586 L47.0953383,55.9514586 Z",
    id: "Fill-6",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "30.0078195 23.3221053 49.9909774 23.3221053 49.9909774 22.7470677 30.0078195 22.7470677"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "35.7786466 21.5103759 43.5572932 21.5103759 43.5572932 21.2637594 35.7786466 21.2637594"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "30.0078195 52.2406015 49.9909774 52.2406015 49.9909774 51.9945865 30.0078195 51.9945865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.997594,52.8021053 C39.4381955,52.8021053 38.9834586,53.2568421 38.9834586,53.8162406 C38.9834586,54.3744361 39.4381955,54.8291729 39.997594,54.8291729 C40.556391,54.8291729 41.0111278,54.3744361 41.0111278,53.8162406 C41.0111278,53.2568421 40.556391,52.8021053 39.997594,52.8021053 M39.997594,54.993985 C39.3479699,54.993985 38.8198496,54.4658647 38.8198496,53.8162406 C38.8198496,53.166015 39.3479699,52.6384962 39.997594,52.6384962 C40.6466165,52.6384962 41.1753383,53.166015 41.1753383,53.8162406 C41.1753383,54.4658647 40.6466165,54.993985 39.997594,54.993985",
    id: "Fill-12",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#3A913F",
    mask: "url(#mask-4)",
    points: "28.4827068 29.3263759 28.4827068 42.2304361 32.2896241 38.9173534 36.6114286 43.2770526 40.0069173 39.7901353 43.5052632 44.8469774 45.4607519 39.9645714 48.4442105 44.8469774 51.3254135 40.1390075 51.3254135 29.3263759 49.8974436 33.337203 48.032782 37.0863759 45.5630075 34.383218 44.526015 37.8713383 42.4682707 34.208782 39.9040602 36.302015 37.0228571 39.9645714 34.9651128 34.208782 33.6273684 37.0863759 28.4827068 28.4541955"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-14",
    fill: "#3A913F",
    mask: "url(#mask-4)",
    points: "30.0081805 29.1113985 29.9618647 31.5354586 32.098406 33.8362105 35.0566015 30.5989173 36.9459248 32.7270376 38.6301353 30.5989173 40.2325414 34.3294436 44.0538947 31.0025263 44.6698346 34.3294436 46.6409624 30.8786165 49.5179549 36.6500451 49.9913383 37.9005714 49.9913383 30.7547068"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "50.2789774 39.4709173 49.2534135 36.7659549 46.6242406 31.4883609 44.529203 35.1533233 43.8621353 31.5491128 40.1237895 34.8050526 38.5568722 31.1551278 36.9580752 33.1743759 35.0531128 31.0282105 32.0997293 34.2606917 29.6720602 31.6459549 29.720782 29.1070075 30.2958195 29.1172331 30.2513083 31.425203 32.0961203 33.4119699 35.0591278 30.1686617 36.9334135 32.2793383 38.7042406 30.0417444 40.3415338 33.8534737 44.2446917 30.4537744 44.8095038 33.505203 46.6579248 30.2679098 49.7039398 36.379188 49.7039398 30.7551278 50.2789774 30.7551278"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.9911579,
    y1: 32.3985564,
    x2: 49.9911579,
    y2: 29.9329925,
    id: "Fill-16",
    fill: "#7FB22F",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "49.7040602 32.398797 50.2790977 32.398797 50.2790977 29.9332331 49.7040602 29.9332331"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-18",
    fill: "#3A913F",
    mask: "url(#mask-4)",
    points: "49.9911579 45.2163008 49.9911579 40.697203 47.6687519 37.0827669 45.8191278 40.5522406 44.2588271 36.6502857 41.9171729 41.3955489 39.4076992 35.6030677 38.2197293 40.4096842 36.2064962 36.0553985 35.0022857 41.653594 29.9616842 36.0553985 30.008 41.7654737"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "50.2789774 45.2163008 49.7039398 45.2163008 49.7039398 40.7814135 47.6913083 37.649985 45.7821353 41.2337444 44.2314586 37.3564511 41.9000301 42.0800602 39.4825865 36.4987068 38.3024361 41.2734436 36.3066466 36.9576541 35.1649925 42.2647218 30.2555188 36.8108872 30.2958195 41.7630677 29.720782 41.7678797 29.6672481 35.2987068 34.8395789 41.0436692 36.1063459 35.1537444 38.1364211 39.5453233 39.3334135 34.7068271 41.9337143 40.7116391 44.2861955 35.9447218 45.8561203 39.8707368 47.645594 36.5137444 50.2789774 40.6129925"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "26.6972632 29.9108571 23.6777143 26.8907068 24.0843308 26.4846917 27.1044812 29.5036391"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "20.8403008 33.5073684 26.7157895 33.5073684 26.7157895 32.9323308 20.8403008 32.9323308"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "22.8935338 41.2701353 22.4863158 40.8635188 26.7798496 36.571188 27.1864662 36.977203"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "53.5003308 30.6093233 53.0937143 30.2021053 56.1138647 27.1831579 56.5204812 27.5891729"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-24",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "53.4815038 34.2057143 59.3569925 34.2057143 59.3569925 33.6306767 53.4815038 33.6306767"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "57.3049624 41.9685414 53.0108271 37.675609 53.4180451 37.269594 57.7115789 41.5619248"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile1);
export default __webpack_public_path__ + "static/media/mobile-1.30b12f9f3397c081eece42ea9d907f37.svg";
export { ForwardRef as ReactComponent };